import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// utils
import { Translations, convertStringToArray, electOwningCase } from '../../../utils/';
// restClient
import { aemHostClient, taxonomyHostClient } from '../../../restClient';
// children
import NavigationList from '../../common/NavigationList/';
//action Creator
import { updateTempRefInCase, deleteProduct } from '../actions/actionCreator';
import { setDarkTitleBarContent } from '../../layouts/actions/actionCreator';
//style
import './styles.css';

const AddAccount = (props) => {

  const [pageJson, setPageJson] = useState();
  const [currentListCountries, setCurrentListCountries] = useState();


  const translateWord = (word) => {
    var currentWord = Translations(word, props.lang.currentLang.lang, props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_accounts");
      setPageJson(data);
      if (pageJson && pageJson.par) {
        (async () => {
          const { data } = await taxonomyHostClient(translations(pageJson.par.navigation_list_accountList.accountTaxonomy));
          setCurrentListCountries(data.responseData.countryTaxonomy.classificationNodes);
        })();
      }
    })();

    window.localStorage.setItem('owningCase', props.owningCase.caseId);
    (async () => {
      const { data } = await aemHostClient("/aemData/formData/json_dark-title-bar");
      props.setDarkTitleBarContent(translations(data.par.static_text_darkTitleBar.createCase), true, translations(data.par.static_text_darkTitleBar.caseList), undefined, undefined);
    })();

  }, []);

  useEffect(() => {
    if (pageJson && pageJson.par) {
      document.title = `${Translations(pageJson.par.page_title_mainTitle.pageHeading, props.lang.currentLang.lang, props.lang.translatedData)} - ${'HSBC GLCM'}`;
      props.updateBreadCrumbsState(2);
    }
  }, [pageJson]);

  useEffect(() => {
    if (pageJson && pageJson.par) {
      (async () => {
        const { data } = await taxonomyHostClient(translations(pageJson.par.navigation_list_accountList.accountTaxonomy));
        setCurrentListCountries(data.responseData.countryTaxonomy.classificationNodes)
      })();
    }
  }, [props.lang.currentLang.lang]);

  const topreviouspage = () => {
    props.history.push("/create-a-case/select-entity")
  }

  const toNextpage = () => {
    props.history.push("/create-a-case/add-echannel")
  }

  const formpage = () => {
    props.history.push("/create-a-case/create-new-account")
  }

  const finish = () => {
    props.history.push('/case-body')
  }

  let jsx = (<h3>Loading.....</h3>);

  if (pageJson !== undefined) {

    const title = pageJson.par.page_title_mainTitle;
    const deleteAccountModal = pageJson.par.modal_deleteAccountModal;
    jsx = (
      <div className="selectcustomercontainer">
        <h2>{translations(title.pageHeading)}</h2>
        <div className="row accountcontainer">
          <div className="col-lg-8 leftcontent">
            <p>{translations(title.descriptionText)}</p>
          </div>
          <div className="col-lg-4 rgtcontt">
            <button className="btn btn-primary btnaddwrapper" id="addNewAcc"
              onClick={formpage}><span className="icon icon-add addicon"></span> {translations(pageJson.par.button_addNewAccounts.text)}</button>
          </div>
        </div>
        <NavigationList cases={props.cases}
          history={props.history}
          listtype="accountVersion"
          countryList={currentListCountries}
          deleteProduct={props.deleteProduct}
          deleteModalContent={deleteAccountModal || {}}
          pageReferer="accountPage" />
        <div id="btnwrapperid" className={props.cases.length === 0 ? 'btnWrapper addaccountbtn' : 'btnWrapper setbtnpadd'}>
          <div className="leftbtn">
            <button onClick={topreviouspage} id="disabledpreviousbtn" style={{ paddingTop: '10px' }} className={props.cases.length === 0 ? 'btn btn-primary btndisable btnpmg' : 'btn btn-primary btnpmg'}><b>{translations(pageJson.par.button_previous.textPrevious)}:</b> {translations(pageJson.par.button_previous.text)}</button>
          </div>
          <div className="rightbtn">
            <button id="disabledFinsh" onClick={finish} className='btn btn-primary btnmrg'>{translations(pageJson.par.button_finish.text)}</button>
            <button onClick={toNextpage} id="disablednextbt" className='btn btn-primary btnbg'><b>{translations(pageJson.par.button_nextEChannels.textNext)}:</b> {translations(pageJson.par.button_nextEChannels.text)}</button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      {jsx}
    </div>
  )

}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    lang: state.lang,
    owningCase: electOwningCase(state.cases)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    deleteProduct: (caseId, productType, productId) => {
      dispatch(deleteProduct(caseId, productType, productId))
    },
    updateCaseWithTempRef: (caseId, tempRefId) => {
      dispatch(updateTempRefInCase(caseId, tempRefId))
    },
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    }
  }
}

AddAccount.propTypes = {
  roleDetails: PropTypes.object,
  lang: PropTypes.object,
  history: PropTypes.object,
  owningCase: PropTypes.object
};


export default connect(mapStateToProps, mapDispatchToProps)(AddAccount);



// WEBPACK FOOTER //
// ./src/components/createAcase/AddAccount/index.js